import React from 'react';

type Props = {
    size: number;
};

export const FacebookColoredIcon = ({size = 14}: Props) => {
    return <img alt='Facebook icon' style={{width: size}} src='/include/images/facebook.png' />;
};
